export default __webpack_public_path__ + "static/media/britannia.dcb2a1ea.png";